module.exports = __webpack_public_path__ + "img/bocom.5943e820.jpg";